export default {
  // Common Buttons
  example: "Criar Novo",
};
